import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { Starfield } from "@/components/Starfield";
import { Nav } from "@/components/Nav";
import { Hero } from "@/components/Hero";
import { GlobeSection } from "@/components/GlobeSection";
import { Story } from "@/components/Story";
import { Gallery } from "@/components/Gallery";
import { Philosophy } from "@/components/Philosophy";
import { ShamanicPreview } from "@/components/ShamanicPreview";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";
import { AuthCallback } from "@/components/AuthCallback";
import MomentsPage from "@/pages/MomentsPage";
import AdminPage from "@/pages/AdminPage";
import StoryPage from "@/pages/StoryPage";
import ShamanicPath from "@/pages/ShamanicPath";
import RawNotes from "@/pages/RawNotes";

function Home() {
  return (
    <>
      <Nav />
      <main className="relative z-10">
        <Hero />
        <Story />
        <GlobeSection />
        <Gallery />
        <Philosophy />
        <ShamanicPreview />
        <Contact />
        <Footer />
      </main>
    </>
  );
}

function AppShell() {
  const location = useLocation();
  // Process OAuth session_id FIRST (synchronously, before any protected route runs)
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/story" element={<StoryPage />} />
      <Route path="/moments" element={<MomentsPage />} />
      <Route path="/shamanic-path" element={<ShamanicPath />} />
      <Route path="/raw-notes" element={<RawNotes />} />
      <Route path="/admin" element={<AdminPage />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App grain relative">
      <BrowserRouter>
        <Starfield />
        <AppShell />
        <Toaster
          position="bottom-center"
          toastOptions={{
            style: {
              background: "#120E1A",
              color: "#EBE4D8",
              border: "1px solid rgba(214,181,109,0.3)",
            },
          }}
        />
      </BrowserRouter>
    </div>
  );
}

export default App;
